import React from 'react';
import { motion } from 'framer-motion';
import { Play, Pause, SkipBack, SkipForward } from 'lucide-react';
import { useAudioStore } from '@/hooks/useAudioStore';
import { useAudioPlayer } from '@/hooks/useAudioPlayer';
import { getSolidColor } from '@/utils/streamColor';

const DEFAULT_COLOR = '#3b82f6';

interface PlaybackControlsProps {
  stationColor?: string;
}

export const PlaybackControls: React.FC<PlaybackControlsProps> = ({ stationColor = DEFAULT_COLOR }) => {
  const { isPlaying } = useAudioStore();
  const { togglePlayPause } = useAudioPlayer();
  const color = stationColor || DEFAULT_COLOR;
  const solidColor = getSolidColor(color);

  return (
    <div className="flex items-center justify-center gap-4 sm:gap-6" onClick={(e) => e.stopPropagation()}>
      {/* Previous */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="flex-shrink-0 w-12 h-12 aspect-square rounded-full glass flex items-center justify-center hover:bg-white/10 transition-colors"
      >
        <SkipBack className="w-5 h-5" />
      </motion.button>

      {/* Play/Pause - boja trenutne stanice */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={togglePlayPause}
        className="relative flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 aspect-square rounded-full flex items-center justify-center transition-all duration-300"
        style={{
          background: color,
          boxShadow: `0 10px 40px ${solidColor}50`,
        }}
      >
        {/* Glow effect */}
        {isPlaying && (
          <motion.div
            animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0.2, 0.5] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="absolute inset-0 rounded-full"
            style={{ backgroundColor: solidColor }}
          />
        )}
        
        {isPlaying ? (
          <Pause className="w-6 h-6 sm:w-8 sm:h-8 fill-current relative z-10" />
        ) : (
          <Play className="w-6 h-6 sm:w-8 sm:h-8 fill-current relative z-10 ml-1" />
        )}
      </motion.button>

      {/* Next */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="flex-shrink-0 w-12 h-12 aspect-square rounded-full glass flex items-center justify-center hover:bg-white/10 transition-colors"
      >
        <SkipForward className="w-5 h-5" />
      </motion.button>
    </div>
  );
};
